import React from 'react'

const ButtonLink = (props) => (
    <a onClick={props.onClick} style={{ cursor: 'pointer' }}>
        {
            props.text
        }
    </a>
)

export default ButtonLink;


// WEBPACK FOOTER //
// ./src/components/ButtonLink.js